
















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Machine } from '@/models/machine';

@Component({
  components: {
    MaintenanceListTableRow: () => import('../components/MaintenanceListTableRow.component.vue'),
  }
})
export default class ChecklistPreviewComponent extends Vue {
  @Prop({ required: true }) forms!: any[];
  @Prop({ required: true }) currentMachine!: Machine;


  mounted() {
    // console.log('currentMachine', this.currentMachine);
  }

  get headers() {
    return [
      { text: 'Teil', value: 'maintenanceListElement' },
      { text: 'Zustand', value: 'controlStatus' },
      { text: 'Bemerkungen', value: 'comment' },
    ];
  }

  public getFormType(form: any) {
    switch (form.formType) {
      case 'condition':
        return 'Zustand der Anlage';
      case 'function':
        return 'Funktion der Anlage';
      default:
        return form.formType;
    }
  }
}
